import type { CSSProperties } from 'react';

/** Tooltip + grid colors follow GGJ mobile theme (vscode CSS variables). */
export const rechartsTooltipStyle: CSSProperties = {
  background: 'var(--vscode-bg-elevated)',
  border: '1px solid var(--vscode-border-primary)',
  borderRadius: 8,
  color: 'var(--vscode-text-primary)',
};

export const rechartsGridStroke = 'var(--vscode-border-primary)';
